import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["servicesSelect", "selectedList", "total"]
  static values = { updateUrl: String }
  
  connect() {
    console.log("Pre-invoice controller connected")
  }
  
  async servicesChanged(event) {
    // Tom-select puede cambiar el elemento, buscar el select original
    setTimeout(async () => {
      const select = document.getElementById('dental_service_ids') || this.servicesSelectTarget
      if (!select) {
        console.error("No se encontró el select")
        return
      }
      
      const selectedIds = Array.from(select.selectedOptions).map(option => option.value)
      console.log("Services changed, selected IDs:", selectedIds)
      
      // Hacer petición al servidor con Turbo Streams
      try {
        const response = await post(this.updateUrlValue, {
          body: JSON.stringify({ service_ids: selectedIds }),
          contentType: "application/json",
          responseKind: "turbo-stream"
        })
        
        if (response.ok) {
          // Después de que Turbo actualice el DOM, actualizar el total
          setTimeout(() => {
            this.updateTotal()
          }, 100)
        }
      } catch (error) {
        console.error("Error al actualizar servicios:", error)
      }
    }, 100)
  }
  
  updateTotal() {
    let total = 0
    
    const rows = this.selectedListTarget.querySelectorAll('[data-service-id]')
    
    rows.forEach(row => {
      const quantityInput = row.querySelector('input[type="number"]')
      if (!quantityInput) return
      
      const price = parseFloat(quantityInput.dataset.price) || 0
      const quantity = parseInt(quantityInput.value) || 1
      const subtotal = price * quantity
      
      // Actualizar subtotal de la fila
      const subtotalElement = row.querySelector('[data-subtotal]')
      if (subtotalElement) {
        subtotalElement.textContent = `$${this.formatNumber(subtotal)}`
      }
      
      total += subtotal
    })
    
    // Actualizar total general
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = `$${this.formatNumber(total)}`
    }
  }
  
  formatNumber(number) {
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}
